/**
 * AlmadarPostWhyStateMachinesForBusinessENAlmadarPostWhyStateMachinesForBusinessENPage
 *
 * Page component for AlmadarPostWhyStateMachinesForBusinessENAlmadarPostWhyStateMachinesForBusinessENPage
 * Path: /blog/why-state-machines-for-business
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AlmadarPostWhyStateMachinesForBusinessENPostPageView as __AlmadarPostWhyStateMachinesForBusinessENPostPageView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessENPostPageView';
import { AlmadarPostWhyStateMachinesForBusinessENPostAnalyticsView as __AlmadarPostWhyStateMachinesForBusinessENPostAnalyticsView } from '@/components/traits/AlmadarPostWhyStateMachinesForBusinessENPostAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';

interface AlmadarPostWhyStateMachinesForBusinessENAlmadarPostWhyStateMachinesForBusinessENPageProps {
  // Add any page-level props here
}

export function AlmadarPostWhyStateMachinesForBusinessENAlmadarPostWhyStateMachinesForBusinessENPage(_props: AlmadarPostWhyStateMachinesForBusinessENAlmadarPostWhyStateMachinesForBusinessENPageProps) {
  const __navState = (useLocation().state ?? {}) as EventPayload;

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AlmadarPostWhyStateMachinesForBusinessENPostPageView config={{ initPayload: __navState }} />
          <__AlmadarPostWhyStateMachinesForBusinessENPostAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AlmadarPostWhyStateMachinesForBusinessENAlmadarPostWhyStateMachinesForBusinessENPage;
